<template>
  <div
    class="modal fade"
    id="modal-block-custom-css"
    tabindex="-1"
    role="dialog"
    aria-labelledby="modal-block-custom-css"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-block-custom-css modal-lg" role="document">
      <div class="modal-content">
        <div class="block block-themed block-transparent mb-0">
          <div class="block-header bg-primary-dark">
            <h3 class="block-title">Custom CSS</h3>
            <div class="block-options">
              <button
                type="button"
                class="btn-block-option"
                data-dismiss="modal"
                aria-label="Close"
              >
                <i class="fa fa-fw fa-times"></i>
              </button>
            </div>
          </div>
          <form @submit="saveCss">
            <div class="block-content">
              Please write 1 attribute per line and no whitespaces
              <br />
              Example :
              <br />
              background-color:red <br />
              color:blue
              <div class="col-sm-12">
                <label>.block-title{} :</label>
                <textarea
                  type="text"
                  class="mb-2 mr-sm-2 mb-sm-0 form-control"
                  id="block-title-css"
                />
              </div>
              <div class="col-sm-12">
                <label>.block-content{} :</label>
                <textarea
                  type="text"
                  class="mb-2 mr-sm-2 mb-sm-0 form-control"
                  id="block-content-css"
                />
              </div>
              <div class="col-sm-12">
                <label>.modal-content{} :</label>
                <textarea
                  type="text"
                  class="mb-2 mr-sm-2 mb-sm-0 form-control"
                  id="modal-content-css"
                />
              </div>
              <div class="col-sm-12">
                <label>body{} :</label>
                <textarea
                  type="text"
                  class="mb-2 mr-sm-2 mb-sm-0 form-control"
                  id="body-css"
                />
              </div>
              <div class="col-sm-12">
                <label>.block-header-default{} :</label>
                <textarea
                  type="text"
                  class="mb-2 mr-sm-2 mb-sm-0 form-control"
                  id="block-header-css"
                />
              </div>
              <div class="col-sm-12">
                <label>.utility{} :</label>
                <textarea
                  type="text"
                  class="mb-2 mr-sm-2 mb-sm-0 form-control"
                  id="utility-css"
                />
              </div>
              <div class="col-sm-12">
                <label>.more{} :</label>
                <textarea
                  type="text"
                  class="mb-2 mr-sm-2 mb-sm-0 form-control"
                  id="more-css"
                />
              </div>
              <div class="col-sm-12">
                <label>.button{} :</label>
                <textarea
                  type="text"
                  class="mb-2 mr-sm-2 mb-sm-0 form-control"
                  id="button-css"
                />
              </div>
              <div class="col-sm-12">
                <label>.nav{} :</label>
                <textarea
                  type="text"
                  class="mb-2 mr-sm-2 mb-sm-0 form-control"
                  id="nav-css"
                />
              </div>
              <div class="col-sm-12">
                <label>.h{} :</label>
                <textarea
                  type="text"
                  class="mb-2 mr-sm-2 mb-sm-0 form-control"
                  id="h-css"
                />
              </div>
              <div class="col-sm-12">
                <label>.alert-info{} :</label>
                <textarea
                  type="text"
                  class="mb-2 mr-sm-2 mb-sm-0 form-control"
                  id="alert-info-css"
                />
              </div>
            </div>
            <div class="modal-footer">
              <button type="submit" class="btn btn-primary">
                Save Changes
              </button>
              <button
                type="button"
                id="closeButton"
                class="btn btn-secondary"
                data-dismiss="modal"
              >
                Close
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
export default {
  name: "CustomCssModal",
  methods: {
    saveCss(e) {
      e.preventDefault();
      let form = this.form;
      let blockTitle = document.getElementById("block-title-css").value;
      let blockContent = document.getElementById("block-content-css").value;
      let modalContent = document.getElementById("modal-content-css").value;
      let body = document.getElementById("body-css").value;
      let blockHeader = document.getElementById("block-header-css").value;
      let utility = document.getElementById("utility-css").value;
      let more = document.getElementById("more-css").value;
      let button = document.getElementById("button-css").value;
      let nav = document.getElementById("nav-css").value;
      let h = document.getElementById("h-css").value;
      let alertinfo = document.getElementById("alert-info-css").value;

      form.data.attributes = {
        block_title: {
          isTag: false,
          attributes: blockTitle
        },
        block_content: {
          isTag: false,
          attributes: blockContent
        },
        modal_content: {
          isTag: false,
          attributes: modalContent
        },
        body: {
          isTag: true,
          attributes: body
        },
        block_header: {
          isTag: false,
          attributes: blockHeader
        },
        utility: {
          isTag: false,
          attributes: utility
        },
        more: {
          isTag: false,
          attributes: more
        },
        button: {
          isTag: true,
          attributes: button
        },
        nav: {
          isTag: true,
          attributes: nav
        },
        h: {
          isTag: true,
          attributes: h
        },
        alert_info: {
          isTag: false,
          attributes: alertinfo
        }
      };
      this.$forceUpdate();
      this.processCss();
      $(function() {
        $("#closeButton").trigger("click");
      });
    },
    processCss() {
      Object.keys(this.form.data.attributes).map(a => {
        if (this.form.data.attributes[a].isTag) {
          let cssAttributes = this.form.data.attributes[a].attributes.split(
            "\n"
          );
          $(a).removeAttr("style");
          cssAttributes.map(x => {
            let attribute = x.split(":")[0];
            let value = x.split(":")[1];
            $(a).css(`${attribute}`, value);
          });
        } else {
          let className = a.replace("_", "-");
          let cssAttributes = this.form.data.attributes[a].attributes.split(
            "\n"
          );
          $(`.${className}`).removeAttr("style");
          cssAttributes.map(x => {
            let attribute = x.split(":")[0];
            let value = x.split(":")[1];
            $(`.${className}`).css(`${attribute}`, value);
          });
        }
      });
    }
  }
};
</script>
<style scoped>
.utility img {
  max-width: 40px;
  display: block;
  margin: 0 auto;
  margin-top: 25px;
}
.utility input {
  display: none;
}
.utility div {
  display: block;
  position: relative;
  border: 1px solid #a0a0a0;
  text-align: center;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  height: 160px;
  cursor: pointer;
  transition: background-color 0.2s, box-shadow 0.2s;
}
.utility .more {
  width: 100%;
  background: #f5fbfd;
  display: block;
  text-align: center;
  color: #1678aa;
  padding: 10px;
  position: absolute;
  bottom: 0;
  left: 0;
  font-weight: normal;
  font-size: 14px;
}
.supplierTab span {
  cursor: pointer;
}
</style>
